import { cfdi } from './cfdi';
import { sat } from './sat';
import { uploads } from './uploads';
import { configure } from './http';

export { downloadUrls } from './downloads';
export { serverOrigin } from './endpoints';
export { configure };
export { setFiscalpopApiAuthToken } from './auth';

export const fiscalpopApi = {
    cfdi,
    sat,
    uploads,
    configure,
};
